/*!
 * Black Dashboard PRO React - v1.0.0
 * Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Coded by Creative Tim
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import Users from '../src/views/Users.jsx';
import ReferralPartners from '../src/views/ReferralPartners.jsx';
import Dashboard from '../src/components/Global/Dashboard.jsx';
import MerchantList from '../src/components/Merchant/MerchantList';
import CreateDeliveryForMerchant from '../src/components/Dispatch/CreateOrderForMerchant/MainPage';
import DocumentationViewer from './components/W9-COL/DocumentationViewer.js';
import Metrics from '../src/views/Metrics.jsx';
import SubscriptionPage from '../src/views/SubscriptionPage.jsx';
import AccountingDashboard from './views/AccountingDashboard.jsx';
import CRMDashboard from './views/CRMDashboard.jsx';
import { MetricsIcon, ReferralPartnersIcon, StoreManagerIcon, CrmIcon } from './assets/svgs/SideBarIcons';

const merchantRoutes = [
  {
    collapse: false,
    name: 'Order Dashboard',
    path: '/dashboard',
    rtlName: 'إستمارات',
    icon: 'tim-icons icon-delivery-fast',
    component: Dashboard,
    layout: '/admin'
  },
  {
    collapse: false,
    // Hidden from the customer sidebar (redirect) — customers use the in-page "Create Delivery" button; route stays routable.
    redirect: true,
    name: 'Delivery Creation',
    path: '/delivery_creation',
    icon: 'tim-icons icon-cart',
    component: CreateDeliveryForMerchant,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Customer Manager',
    path: '/inventory',
    iconComponent: StoreManagerIcon,
    component: MerchantList,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Documentation',
    path: '/documentation',
    icon: 'tim-icons icon-paper',
    component: DocumentationViewer,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Metrics',
    path: '/metrics',
    iconComponent: MetricsIcon,
    component: Metrics,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Subscription',
    path: '/subscription',
    icon: 'tim-icons icon-credit-card',
    component: SubscriptionPage,
    layout: '/admin'
  }
];

const inventoryManagerRoutes = [
  {
    collapse: false,
    name: 'Order Dashboard',
    path: '/dashboard',
    rtlName: 'إستمارات',
    icon: 'tim-icons icon-delivery-fast',
    component: Dashboard,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Customer Manager',
    path: '/inventory',
    iconComponent: StoreManagerIcon,
    component: MerchantList,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Documentation',
    path: '/documentation',
    icon: 'tim-icons icon-paper',
    component: DocumentationViewer,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Metrics',
    path: '/metrics',
    iconComponent: MetricsIcon,
    component: Metrics,
    layout: '/admin'
  }
];

const pickerRoutes = [
  {
    collapse: false,
    name: 'Order Dashboard',
    path: '/dashboard',
    rtlName: 'إستمارات',
    icon: 'tim-icons icon-delivery-fast',
    component: Dashboard,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Documentation',
    path: '/documentation',
    icon: 'tim-icons icon-paper',
    component: DocumentationViewer,
    layout: '/admin'
  }
];

const adminRoutes = [
  {
    collapse: false,
    name: 'Shipment Dashboard',
    path: '/dashboard',
    rtlName: 'إستمارات',
    icon: 'tim-icons icon-delivery-fast',
    component: Dashboard,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Delivery Creation',
    path: '/delivery_creation',
    icon: 'tim-icons icon-cart',
    component: CreateDeliveryForMerchant,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Customer Manager',
    path: '/inventory',
    iconComponent: StoreManagerIcon,
    component: MerchantList,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'User Management',
    path: '/users',
    rtlName: 'المكونات',
    icon: 'tim-icons icon-badge',
    component: Users,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Referral Partners',
    path: '/referral-partners',
    iconComponent: ReferralPartnersIcon,
    component: ReferralPartners,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Documentation',
    path: '/documentation',
    icon: 'tim-icons icon-paper',
    component: DocumentationViewer,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Metrics',
    path: '/metrics',
    iconComponent: MetricsIcon,
    component: Metrics,
    layout: '/admin'
  },
  {
    collapse: false,
    name: 'Accounting',
    path: '/accounting',
    icon: 'tim-icons icon-bank',
    component: AccountingDashboard,
    layout: '/admin',
    requiresAccountingAccess: true
  },
  {
    collapse: false,
    name: 'CRM',
    path: '/crm',
    iconComponent: CrmIcon,
    component: CRMDashboard,
    layout: '/admin',
    requiresCrmAccess: true
  }
];

export { merchantRoutes, adminRoutes, pickerRoutes, inventoryManagerRoutes };
